
import './App.css';
import Home from './pages/Home'
import Cart from './pages/Cart'
import {createBrowserRouter, Outlet, RouterProvider} from 'react-router-dom'
import Header from './components/Header'
import NavBarBottom from './components/NavBarBottom'
import { ProductsData } from './api/Api';
import Product from './components/Product';
import LogIn from './pages/Account';
import Admin from './pages/admin/Admin';
import AllProducts from './components/admin/AllProducts';
import Orders from './pages/Orders';
import EditProduct from './components/admin/EditProduct';
import AddProduct from './components/admin/AddProduct';
import { useSelector } from 'react-redux';
import OrderDetails from './components/OrderDetails';
import DummyPay from './components/payment/DummyPay';
import Failed from './components/payment/Failed';
import Success from './components/payment/Success';
import AllOrders from './components/admin/AllOrders';
import Dashboard from './components/admin/Dashboard';
import Address from './components/user/Address';
import ChangeAddress from './components/user/ChangeAddress';
import Information from './components/extra/Information';
import RequestListing from './components/user/RequestListing';
import ListingRequests from './components/admin/ListingRequests';
import Support from './components/user/Support';




const Layout = ()=>{
  return (
    <>
    <Header/>
    <Outlet/>
    <NavBarBottom/>
    </>
  )
}

const AdminPannel = ()=>{
  const userInfo = useSelector((state)=> state.shopsyReducer.userInfo)
  console.log(userInfo);

  return(
    <>
    
      <Admin/>
      
    </>
  )
}

const router = createBrowserRouter([
    {
      path:'/',
      element: <> <Layout/> </>,
      children: [
        {
          path:'/',
          element: <Home/>,
          loader: ProductsData,
        },
        {
          path:'/info',
          element: <Information/>
        },
        {
          path:'/product/:id',
          element: <Product/>
        },
        {
          path:'/cart',
          element: <Cart/>
        },
        {
          path:'/account',
          element: <LogIn/>
        },
        {
          path: 'request-listing',
          element: <RequestListing/>
        },
        {
          path:'/address',
          element: <Address/>,
        },  
        {
          path:'address/change',
          element: <ChangeAddress/>
        },
        {
          path:'/orders',
          element: <Orders/>,
         },
         {
          path:'/support',
          element: <Support/>
         },
         {
           path:'/order/:id',
           element: <OrderDetails/>
         },
         {
          path:'/payment-gateway/demo-pay',
          element: <DummyPay/>,
          },
            {
              path: '/payment-gateway/demo-pay/payment-failed',
              element: <Failed/>
            },
            {
              path: '/payment-gateway/demo-pay/order-placed',
              element: <Success/>
            },
          
         
      ],
      /* errorElement: <ErrorHandler/>, */
    },
        {
          path:'/admin',
          element: <><AdminPannel/></>,
          children:[
            {
              path:'/admin',
              element: <Dashboard/>
            },
            {
              path:'/admin/products',
              element: <AllProducts/>
            },
            {
              path:'/admin/orders',
              element:<Orders/>
            },
            {
              path:'/admin/edit-product/:id',
              element: <EditProduct/>
            },
            {
              path:'/admin/add-product',
              element: <AddProduct/>
            },
            {
              path: '/admin/all-orders',
              element: <AllOrders/>
            },
            {
              path: '/admin/listing-requests',
              element: <ListingRequests/>
            }
          ]
        },
  ])

function App() {

 

  return (
    <div className="App">
      <header className="App-header">
        <RouterProvider router={router} />
      </header>
    </div>
  );
}



export default App;
